import { createFileRoute } from '@tanstack/react-router';

import { VerifyEmailPage } from '@/auth/pages/verify-email';

export const Route = createFileRoute('/users/verify-email/$token')({
  component: VerifyEmailRoute
});

function VerifyEmailRoute() {
  const { token } = Route.useParams();

  return <VerifyEmailPage token={token}/>;
}
